import React from "react";
import { styled } from '@mui/material/styles';
import { Grid } from "@mui/material";
import UnderwritingSidenav from "ui/sites/underwriting/components/UnderwritingSidenav";
import CurrentUnderwriterProvider from "ui/sites/underwriting/providers/CurrentUnderwriterProvider";
import { withNotifications } from "ui/contexts/NotificationsContext";
import { SidenavWrapper } from "ui/contexts/SidenavContext";
import Routes from "ui/sites/underwriting/Routes";
import { SiteWrapper } from "ui/contexts/SiteContext";

const PREFIX = 'UnderwritingSite';

const classes = {
  container: `${PREFIX}-container`
};

const StyledSiteWrapper = styled(SiteWrapper)((
  {
    theme
  }
) => ({
  [`& .${classes.container}`]: {
    height: "100%"
  }
}));

function UnderwritingSite() {

  return (
    <StyledSiteWrapper site="underwriting">
      <Grid container className={classes.container}>
        <SidenavWrapper Component={UnderwritingSidenav}>
          <Grid size="grow">
            <CurrentUnderwriterProvider>
              <Routes />
            </CurrentUnderwriterProvider>
          </Grid>
        </SidenavWrapper>
      </Grid>
    </StyledSiteWrapper>
  );
}

export default withNotifications(UnderwritingSite);
